import { composeIdentityStateRehydratorMetaReducer } from '@bp/shared-domains-identity';

import { Identity } from '../models';

import type { IState } from './identity.reducer';

export const identityStateRehydratorMetaReducer = composeIdentityStateRehydratorMetaReducer<Identity, IState>(Identity);
